import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { DatePicker } from 'antd';
import moment from 'moment';
import withModal from '../../../core/components/withModals';
import AForm from '../../../core/components/form/AForm';
import FormModalStyled from '../../../core/components/modals/FormModalStyled';
import ASwitch from '../../../core/components/inputs/switch/ASwitch';

const HoursReportModal = (props) => {
  const { t } = useTranslation();
  const { modalProps, closeDialog, modalData, getHoursReport, year, month } = props;
  const monthEnd = new Date(year, month, 0);
  const monthStart = new Date(year, month - 1, 1);

  const [loading, setLoading] = useState(false);
  const [isCurrentMonth, setIsCurrentMonth] = useState(true);
  const [dateFrom, setDateFrom] = useState(monthStart);
  const [dateTo, setDateTo] = useState(monthEnd);

  const validationSchema = Yup.object().shape({
    dateTo: Yup.mixed().test('is-bigger-than-dateFrom', 'Nevalidan izbor datuma', (field, testContext) => {
      if (!isCurrentMonth) {
        const valDateFrom = testContext?.parent?.dateFrom ? testContext?.parent?.dateFrom : moment(new Date());
        const valDateTo = field ? moment(field) : moment(new Date());

        return valDateTo?.isAfter(valDateFrom);
      }
      return true;
    })
  });

  const fields = [
    {
      id: 'currentMonth',
      name: t('monthlyPlan.currentMonth'),
      fieldType: 'switch',
      render: <ASwitch defaultChecked />
    },
    {
      id: 'dateFrom',
      name: t('monthlyPlan.dateFrom'),
      fieldType: 'date',
      disabled: !!isCurrentMonth,
      controlledDateValue: dateFrom,
      render: <DatePicker />
    },
    {
      id: 'dateTo',
      name: t('monthlyPlan.dateTo'),
      fieldType: 'date',
      disabled: !!isCurrentMonth,
      controlledDateValue: dateTo,
      render: <DatePicker />
    }
  ];

  const handleFormStateChange = (formValues) => {
    if (formValues?.currentMonth !== isCurrentMonth || formValues?.dateFrom !== dateFrom || formValues?.dateTo !== dateTo) {
      if (formValues?.currentMonth !== undefined) setIsCurrentMonth(formValues?.currentMonth);
      if (formValues?.currentMonth === true) {
        setDateFrom(moment(monthStart));
        setDateTo(moment(monthEnd));
      } else {
        if (formValues?.dateFrom !== undefined) setDateFrom(formValues?.dateFrom);
        if (formValues?.dateTo !== undefined) setDateTo(formValues?.dateTo);
      }
    }
  };

  const getLocalDateISOString = (date) => {
    const offset = date?.getTimezoneOffset();
    const adjustedDate = new Date(date.getTime() - offset * 60 * 1000);
    return adjustedDate.toISOString().split('T')[0];
  }

  function isMomentObject(variable) {
    return moment.isMoment(variable);
  }

  const submitHandler = async (formValues) => {
    try {
      setLoading(true);
      let dateFromFormatted;
      let dateToFormatted;
      if (isCurrentMonth) {
        dateFromFormatted = getLocalDateISOString(monthStart);
        dateToFormatted = getLocalDateISOString(monthEnd);
      } else {
        if (isMomentObject(formValues?.dateFrom)) {
          dateFromFormatted = moment(formValues?.dateFrom)?.format('YYYY-MM-DD');
        } else if (formValues?.dateFrom) {
          dateFromFormatted = getLocalDateISOString(formValues?.dateFrom);
        } else dateFromFormatted = getLocalDateISOString(new Date());
        if (isMomentObject(formValues?.dateTo)) {
          dateToFormatted = moment(formValues?.dateTo)?.format('YYYY-MM-DD');
        } else if (formValues?.dateTo) {
          dateToFormatted = getLocalDateISOString(formValues?.dateTo);
        } else dateToFormatted = getLocalDateISOString(new Date());
      }
      await getHoursReport(dateFromFormatted, dateToFormatted);
    } catch (e) {
      console.log(e);
    } finally {
      closeDialog();
      setLoading(false);
    }
  }

  return (
    <FormModalStyled
      centered
      maskClosable={false}
      width={550}
      footer={[]}
      {...modalProps}
      title={t('monthlyPlan.exportHoursXls')}
    >
      <AForm
        fields={fields}
        modalData={modalData}
        style={{ height: '250px' }}
        okButtonText={t('buttons.confirm')}
        cancelButtonText={t('buttons.cancel')}
        onCancel={() => {
          closeDialog();
        }}
        disabled={loading}
        validationSchema={validationSchema}
        modalAddHandler={(formData) => submitHandler(formData)}
        modalEditHandler={(formData) => submitHandler(formData)}
        onFormStateChange={handleFormStateChange}
        name="add-user-modal-form"
      />
    </FormModalStyled>
  )
}

export default withModal()(HoursReportModal);
